export enum ConsentTypeEnum {
  WRITER_CONSENT = 'WRITER_CONSENT',
  TERMS_OF_USE = 'TERMS_OF_USE',
  PRIVACY_POLICY = 'PRIVACY_POLICY',
}
